import { FullWidthSpace } from "melco-ui";
import { AmountOfStitches } from "./charts/AmountOfStitches";
import { AmountOfRuns } from "./charts/AmountOfRuns";
import { ThreadBreaks } from "./charts/ThreadBreaks";
import { RunDownTime } from "./charts/RunDownTime";
import { DetailedStatistics } from "./DetailedStatistics";
import {
  StatisticsConfig,
  useStatistics,
} from "../../../hooks/reporting/statistics/useStatistics";
import { fakeDataConfig } from "../../../helper/reporting/reportingHelpers";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  ReportingMelcoMachineStatisticsModelsStatisticListItem,
  ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem,
} from "melco-shared-logic";

type ChartsAndDetailedStatisticsProps = {
  statisticsFilter: StatisticsConfig | undefined;
  isMachineReportingAllowed: boolean;
};

export const ChartsAndDetailedStatistics: React.FC<
  ChartsAndDetailedStatisticsProps
> = ({ statisticsFilter, isMachineReportingAllowed }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { data, loading } = useStatistics(statisticsFilter);
  const [dataToDisplay, setDataToDisplay] =
    useState<ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem>(
      { list: [], total: 0 }
    );

  useEffect(() => {
    setIsLoading(loading ?? false);
  }, [loading]);

  useEffect(() => {
    setIsLoading(true);
    console.log("data ", data?.list);

    if (statisticsFilter?.grouped) {
      const groupedAndSummedList: ReportingMelcoMachineStatisticsModelsStatisticListItem[] =
        data?.list.reduce(
          (
            acc: ReportingMelcoMachineStatisticsModelsStatisticListItem[],
            current: ReportingMelcoMachineStatisticsModelsStatisticListItem
          ) => {
            const group_name = current.group_name || "unnamed";
            const existing = acc.find((item) => item.group_name === group_name);

            if (existing) {
              // If the item with the same name exists, sum the numeric values
              existing.stitches =
                (existing.stitches || 0) + (current.stitches || 0);
              existing.runs = (existing.runs || 0) + (current.runs || 0);
              existing.thread_breaks =
                (existing.thread_breaks || 0) + (current.thread_breaks || 0);
              existing.total_standby_time =
                (existing.total_standby_time || 0) +
                (current?.total_standby_time
                  ? current?.total_standby_time / 60
                  : 0);
              existing.total_idle_time =
                (existing.total_idle_time || 0) +
                (current?.total_idle_time ? current.total_idle_time / 60 : 0);
              existing.total_running_time =
                (existing.total_running_time || 0) +
                (current?.total_running_time
                  ? current?.total_running_time / 60
                  : 0);
            } else {
              // If no existing item is found, add the current item as a new entry
              acc.push({
                ...current,
                group_name,
                total_standby_time: current?.total_standby_time
                  ? current.total_standby_time / 60
                  : 0,
                total_idle_time: current?.total_idle_time
                  ? current?.total_idle_time / 60
                  : 0,
                total_running_time: current?.total_running_time
                  ? current?.total_running_time / 60
                  : 0,
              });
            }

            return acc;
          },
          []
        );

      setDataToDisplay({
        list: groupedAndSummedList ?? [],
        warning_list: data?.warning_list ?? [],
        total: data?.total ?? 0,
      });
      console.log(groupedAndSummedList);
    } else {
      const machineList = data?.list.reduce(
        (
          acc: ReportingMelcoMachineStatisticsModelsStatisticListItem[],
          current: ReportingMelcoMachineStatisticsModelsStatisticListItem
        ) => {
          const machine_serial_number =
            current.machine_serial_number || "unnamed";
          const existing = acc.find(
            (item) => item.machine_serial_number === machine_serial_number
          );

          if (existing) {
          } else {
            // If no existing item is found, add the current item as a new entry
            acc.push({
              ...current,
              total_standby_time: current?.total_standby_time
                ? current?.total_standby_time / 60
                : 0,
              total_idle_time: current?.total_idle_time
                ? current?.total_idle_time / 60
                : 0,
              total_running_time: current?.total_running_time
                ? current?.total_running_time / 60
                : 0,
            });
          }

          return acc;
        },
        []
      );

      setDataToDisplay({
        list: machineList ?? [],
        warning_list: data?.warning_list ?? [],
        total: data?.total ?? 0,
      });
    }
    setIsLoading(false);
  }, [data]);

  return (
    <>
      <FullWidthSpace size="large" direction="vertical">
        <AmountOfStitches
          isLoading={isLoading}
          dataConfig={statisticsFilter}
          data={dataToDisplay}
        />
        <AmountOfRuns
          isLoading={isLoading}
          dataConfig={statisticsFilter}
          data={dataToDisplay}
        />
        <ThreadBreaks
          isLoading={isLoading}
          dataConfig={statisticsFilter}
          data={dataToDisplay}
        />
        <RunDownTime
          isLoading={isLoading}
          dataConfig={statisticsFilter}
          data={dataToDisplay}
        />

        <DetailedStatistics
          dataConfig={
            isMachineReportingAllowed ? statisticsFilter : fakeDataConfig
          }
          data={dataToDisplay}
          isLoading={isLoading}
          isMachineReportingAllowed={isMachineReportingAllowed}
        />
      </FullWidthSpace>
    </>
  );
};
